<template>
  <div class="organization-manager">
    <div class="errors" v-if="hasErrors">
      <div
        :key="error"
        class="uk-alert-danger"
        uk-alert
        v-for="error in defaultOrganizationErrors"
      >
        <h3>{{ $t('fields.default') }}</h3>
        {{ error }}
      </div>

      <div
        :key="error"
        class="uk-alert-danger"
        uk-alert
        v-for="error in organizationErrors"
      >
        <h3>{{ $t('fields.active') }}</h3>
        {{ error }}
      </div>
    </div>

    <table class="uk-table uk-table-divider uk-table-justify">
      <thead>
        <tr>
          <th>{{$t('fields.organization')}}</th>
          <th>{{$t('fields.selected')}}</th>
          <th>{{$t('fields.default')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="entry.organization.id" v-for="entry in entries">
          <td>{{entry.organization.name}}</td>
          <td>
            <checkbox
              :disabled="disabled"
              :value="entry.selected"
              @change="toggleSelectedOrganization(entry.organization)"
            />
          </td>
          <td>
            <input
              :checked="entry.default"
              :disabled="isDisabledDefaultEntry(entry)"
              @change="selectDefaultOrganization(entry.organization)"
              name="defaultOrganization"
              type="radio"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from 'lodash';
import Checkbox from '@/components/Checkbox';
import organizationsQuery from '@/api/queries/organizations.graphql';

export default {
  name: 'organization-manager',
  components: {
    Checkbox,
  },
  props: {
    organizations: {
      type: Array,
      default: () => [],
    },
    organizationsErrors: {
      type: Array,
      default: () => [],
    },
    defaultOrganization: Object,
    defaultOrganizationErrors: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
  computed: {
    hasErrors() {
      return this.organizationsErrors.length > 0 ||
        this.defaultOrganizationErrors.length > 0;
    },
    entries() {
      return (this.availableOrganizations || []).map((organization) => {
        const selected = this.isSelectedOrganization(organization);

        let defaultOrg = false;
        if (this.defaultOrganization) {
          defaultOrg = organization.id === this.defaultOrganization.id;
        }

        return { organization, selected, default: defaultOrg };
      });
    },
  },
  apollo: {
    availableOrganizations: {
      query: organizationsQuery,
      update({ organizations }) {
        return organizations.entries;
      },
    },
  },
  methods: {
    isSelectedOrganization(organization) {
      return this.organizations.some(org => org.id === organization.id);
    },
    isDefaultOrganization(organization) {
      if (!this.defaultOrganization) return false;
      return this.defaultOrganization.id === organization.id;
    },
    isDisabledDefaultEntry(entry) {
      return this.disabled || !entry.selected;
    },
    selectOrganization(organization) {
      if (this.isSelectedOrganization(organization)) return;

      const organizations =
        _(this.organizations).concat(organization).uniqBy('id').value();

      if (!this.defaultOrganization) {
        this.selectDefaultOrganization(organizations[0]);
      }

      this.$emit('update:organizations', organizations);
    },
    unselectOrganization(organization) {
      const organizations =
        _.differenceBy(this.organizations, [organization], 'id');

      if (this.isDefaultOrganization(organization)) {
        this.selectDefaultOrganization(organizations[0]);
      }

      this.$emit('update:organizations', organizations);
    },
    toggleSelectedOrganization(organization) {
      if (this.isSelectedOrganization(organization)) {
        this.unselectOrganization(organization);
      } else {
        this.selectOrganization(organization);
      }
    },
    selectDefaultOrganization(organization) {
      this.$emit('update:defaultOrganization', organization);
    },
  },
  i18n: {
    messages: {
      de: {
        fields: {
          organization: 'Name',
          selected: 'Aktiv',
          default: 'Standard',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// OrganizationManager.vue?66246fa8